import React, { useState } from "react";
import PropTypes from "prop-types";
import { Formik, Form } from "formik";
import Box from "@mui/material/Box";
import Radio from "@mui/material/Radio";
import Typography from "@mui/material/Typography";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import { MdError, MdOutlineErrorOutline } from "react-icons/md";
import Loading from "../../../shared/Loading";
import * as CONST from "../Constants";
import * as API from "../api";
import { useStyles } from "./Styles";

const propTypes = {
  id: PropTypes.number.isRequired,
  questions: PropTypes.arrayOf(
    PropTypes.shape({
      statement: PropTypes.string.isRequired,
      options: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.number.isRequired,
          text: PropTypes.string.isRequired,
          number: PropTypes.number.isRequired,
          question_id: PropTypes.number.isRequired,
        })
      ),
    })
  ).isRequired,

  flashHandler: PropTypes.func.isRequired,
};
function MessageTemplate({ questions, id, flashHandler, dispatch }) {
  const styles = useStyles();
  const [loading, setLoading] = useState(false);

  return (
    <>
      {loading && <Loading message={"loading"} />}
      {!loading && (
        <Formik
          initialValues={{
            message_id: id,
            additional_option: "",
            options_ids: questions.map((i, idx) => {
              return {
                id: idx,
                value: i.value,
              };
            }),
          }}
          onSubmit={(values) => {
            setLoading(true);
            const options = values.options_ids.map((i) => i.value);
            let req;
            values.additional_option
              ? (req = { ...values, options_ids: options })
              : (req = { message_id: values.message_id, options_ids: options });
            API.postCustomResponse(req)
              .then((res) => {
                dispatch({
                  type: "set_message_responded",
                  payload: { ...req, id: req.message_id },
                });

                flashHandler({ success: CONST.FLASH.MESSAGE_RESPONSE_SUCCESS });
                setLoading(false);
              })
              .catch((err) => {
                flashHandler({ error: CONST.FLASH.MESSAGE_RESPONSE_ERROR });
              });
          }}
        >
          {({ values, setFieldValue, errors, isSubmitting, touched }) => {
            return (
              <Box mb={3}>
                <Box mt={2} p={2}>
                  <Typography fontWeight={300} className="icon-text">
                    <MdOutlineErrorOutline className="red" />
                    {CONST.FORM_NEEDS_RESPONSE}
                  </Typography>
                </Box>

                <Form>
                  <FormControl>
                    <Box p={2} fontWeight={600} className="bb" color="#1a247e">
                      <ol>
                        {questions.map((i, idx) => (
                          <Box key={idx} pb={2}>
                            <li>
                              {i.statement}
                              <RadioGroup
                                aria-labelledby={i.statement}
                                defaultValue={""}
                                name={values.options_ids.id}
                              >
                                {i.options.map((o) => (
                                  <FormControlLabel
                                    key={o.id}
                                    value={o.id}
                                    control={
                                      <Radio
                                        required={true}
                                        onClick={(e) => {
                                          setFieldValue("options_ids", [
                                            ...values.options_ids.map((j) =>
                                              j.id == idx ? { ...j, value: o.id } : j
                                            ),
                                          ]);
                                        }}
                                        sx={{
                                          "& .MuiSvgIcon-root": {
                                            fontSize: 25,
                                          },
                                        }}
                                      />
                                    }
                                    label={o.text}
                                  />
                                ))}
                              </RadioGroup>
                            </li>
                          </Box>
                        ))}
                      </ol>
                    </Box>

                    <Box px={3} py={2}>
                      <Box fontWeight={600} className="icon-text" my={1} color="#1a247e">
                        {CONST.ADDITIONAL_COMMENTS}
                      </Box>
                      <textarea
                        name="additional_option"
                        onChange={(e) => setFieldValue("additional_option", e.target.value)}
                      />
                      <button type="submit" disabled={isSubmitting} className="prompt confirm">
                        {!loading ? "Submit" : "Loading"}
                      </button>
                    </Box>
                  </FormControl>
                </Form>
              </Box>
            );
          }}
        </Formik>
      )}
    </>
  );
}

MessageTemplate.prototype = propTypes;
export default MessageTemplate;
